import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Link } from "react-router-dom";

const options = {
    loop: true,
    margin: 0,
    autoHeight: true,
    lazyLoad: true,
    nav: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 6000,
    smartSpeed: 300,
    responsive: {
      0: { items: 1 },
      768: { items: 1 },
      1000: { items: 1 },
    },
  };

//   const options2 = {
//   loop: true,
//   margin: 0,
//   autoHeight: true,
//   lazyLoad: true,
//   nav: true,
//   dots: true,
//   autoplay: true,
//   autoplayTimeout: 5000,
//   smartSpeed: 500,
//   responsive: {
//     0: { items: 1 },
//     768: { items: 1 },
//     1024: { items: 1 },
//   },
// };

const options3 = {
  loop: true,
  margin: 30,
  autoHeight: true,
  lazyLoad: true,
  nav: true,
  dots: true,
  autoplay: true,
  autoplayTimeout: 6000,
  smartSpeed: 500,
  responsive: {
    0: { items: 1 },
    600: { items: 2 },
    768: { items: 3 },
    800: { items: 3 },
    1024: { items: 4 },
    1200: { items: 5 },
  },
};

const Home = () => {
  return (
    <>
    <section className="banner-section banner-one">
        <div className="banner-curve"></div>

		<OwlCarousel className="banner-carousel theme-carousel owl-theme owl-carousel" {...options}>
			
	<div className="slide-item">
		<div className="auto-container">
			<div className="content-box">
				<div className="round-layer"></div>
				
				<div className="content">
					<div className="inner">
						<div className="sub-title">Web Development Services</div>
						<h1>We Design & Develop <strong>Websites That Drive Results</strong></h1>
						<div className="text">
							Delivering high-performance, user-focused websites that help businesses grow and stand out online.
						</div>
						<div className="links-box">
							<Link to="/about" className="theme-btn btn-style-one"><div className="btn-title">More Details</div></Link>
						</div>
					</div>
				</div>

				<div className="content-image">
					<img src="assets/images/images/content-image-1.png" alt="" title="" />
				</div>
			</div>  
		</div>
	</div>

	<div className="slide-item">
		<div className="auto-container">
			<div className="content-box">
				<div className="round-layer"></div>

				<div className="content">
					<div className="inner alternate">
						<div className="sub-title">Web Development Services</div>
						<h1><strong>Modern Websites</strong> Built for Business Growth</h1>
						<div className="text">
							Crafting clean, scalable, and conversion-focused websites tailored to your business goals.
						</div>
						<div className="links-box">
							<Link to="/about" className="theme-btn btn-style-one"><div className="btn-title">More Details</div></Link>
							<Link to="/services" className="theme-btn btn-style-two"><div className="btn-title">Our Services</div></Link>
						</div>
					</div>
				</div>

				<div className="content-image">
					<img src="assets/images/images/content-image-1.png" alt="" title="" />
				</div>
			</div>  
		</div>
	</div>

</OwlCarousel>

    </section>

    {/* <!--About Section--> */}
    <section className="about-section">
    <div className="auto-container">
        <div className="row clearfix">

            <div className="text-column col-lg-6 col-md-12 col-sm-12">
                <div className="inner">
                    <div className="sec-title">
                        <div className="upper-text">AlphaBlind – Web Development & IT Solutions</div>
                        <h2>We Build Digital Experiences that <strong>Empower Your Business</strong></h2>
                    </div>

                    <div className="text-content">
                        <p>
                            AlphaBlind specializes in building powerful, scalable, and user-centric web solutions 
                            tailored for businesses across all industries. From corporate websites to 
                            custom web applications, we combine clean design, advanced technology, and strategic thinking 
                            to help clients strengthen their digital presence and achieve measurable growth.
                        </p>

                        <ul className="list-style-one">
                            <li>Custom website design & development for all business sectors</li>
                            <li>High-performance, SEO-friendly, and mobile-optimized web solutions</li>
                            <li>End-to-end services including UI/UX, backend development, and maintenance</li>
                            <li>Experienced team delivering modern, secure, and scalable platforms</li>
                            <li>Long-term support with continuous improvements and reliable service</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="image-column col-lg-6 col-md-12 col-sm-12">
                <div className="inner">
                    <div className="assets/images">
                        <div className="row clearfix">
                            <figure className="image col-md-6 col-sm-6 wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="1500ms">
                                <img src="assets/images/images/about-image-1.jpg" alt="" title="" />
                            </figure>
                            <figure className="image col-md-6 col-sm-6 wow fadeInRight" data-wow-delay="0ms" data-wow-duration="1500ms">
                                <img src="assets/images/images/about-image-2.jpg" alt="" title="" />
                            </figure>
                            <figure className="image col-md-6 col-sm-6 wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="1500ms">
                                <img src="assets/images/images/about-image-3.jpg" alt="" title="" />
                            </figure>
                            <figure className="image col-md-6 col-sm-6 wow fadeInRight" data-wow-delay="0ms" data-wow-duration="1500ms">
                                <img src="assets/images/images/about-image-4.jpg" alt="" title="" />
                            </figure>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>



    {/* <!--Separator--> */}
    <div className="theme-separator"></div>

    {/* <!--Services Section--> */}
   <section className="services-section">
    <div className="gradient-layer"></div>
    <div className="pattern-layer"></div>

    <div className="auto-container">
        <div className="row clearfix">

            {/* Column 1 */}
            <div className="column col-lg-4 col-md-12 col-sm-12">
                <div className="sec-title wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                    <div className="upper-text">AlphaBlind Web & App Services</div>
                    <h2><strong>Our Core Services</strong></h2>
                    <div className="lower-text">Professional digital solutions for business growth</div>
                </div>

                {/* Web Design & Development */}
                <div className="service-block wow fadeInUp" data-wow-delay="300ms" data-wow-duration="1500ms">
                    <div className="inner-box">
                        <div className="icon-outer">
                            <span className="icon-bg"></span>
                            <div className="icon-box"><img src="assets/images/images/web1.png" style={{ width: "150px", height: "150px", objectFit: "contain" }}  alt="" /></div>
                        </div>
                        <h3>Web Design & Development</h3>
                        <div className="text">
                            Modern, responsive, and high-performance websites tailored to your business goals.
                        </div>
                    </div>
                </div>
                

                {/* Android App Development */}
                <div className="service-block wow fadeInUp" data-wow-delay="600ms" data-wow-duration="1500ms">
                    <div className="inner-box">
                        <div className="icon-outer">
                            <span className="icon-bg"></span>
                            <div className="icon-box"><img src="assets/images/images/android.png" alt="" /></div>
                        </div>
                        <h3>Android App Development</h3>
                        <div className="text">
                            Scalable and feature-rich Android applications built for performance and reliability.
                        </div>
                    </div>
                </div>
            </div>

            {/* Column 2 */}
            <div className="column col-lg-4 col-md-12 col-sm-12">

                {/* iOS App Development */}
                <div className="service-block wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                    <div className="inner-box">
                        <div className="icon-outer">
                            <span className="icon-bg"></span>
                            <div className="icon-box"><img src="assets/images/images/ios1.png" alt="" /></div>
                        </div>
                        <h3>iOS App Development</h3>
                        <div className="text">
                            Robust, secure, and elegant iOS applications crafted for seamless user experience.
                        </div>
                    </div>
                </div>

                {/* SEO Services */}
                <div className="service-block wow fadeInUp" data-wow-delay="300ms" data-wow-duration="1500ms">
                    <div className="inner-box">
                        <div className="icon-outer">
                            <span className="icon-bg"></span>
                            <div className="icon-box"><img src="assets/images/images/seo.png" alt="" /></div>
                        </div>
                        <h3>SEO Optimization</h3>
                        <div className="text">
                            Improve website visibility, rank higher on search engines, and attract quality traffic.
                        </div>
                    </div>
                </div>

                {/* UI/UX Design */}
                <div className="service-block wow fadeInUp" data-wow-delay="600ms" data-wow-duration="1500ms">
                    <div className="inner-box">
                        <div className="icon-outer">
                            <span className="icon-bg"></span>
                            <div className="icon-box"><img src="assets/images/images/uiux.png" alt="" /></div>
                        </div>
                        <h3>UI / UX Design</h3>
                        <div className="text">
                            Clean, intuitive, and user-centric designs that enhance digital experiences.
                        </div>
                    </div>
                </div>

            </div>

            {/* Column 3 */}
            <div className="column col-lg-4 col-md-12 col-sm-12">

                {/* E-Commerce Development */}
                <div className="service-block wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                    <div className="inner-box">
                        <div className="icon-outer">
                            <span className="icon-bg"></span>
                            <div className="icon-box"><img src="assets/images/images/ecom1.png" alt="" /></div>
                        </div>
                        <h3>E-Commerce Development</h3>
                        <div className="text">
                            Fast, scalable, and conversion-focused online stores that boost your sales.
                        </div>
                        {/* <div className="more-link">
                            <Link to="/services/ecommerce"><span className="fa fa-arrow-right"></span></Link>
                        </div> */}
                    </div>
                </div>

                {/* Website Maintenance */}
                <div className="service-block wow fadeInUp" data-wow-delay="300ms" data-wow-duration="1500ms">
                    <div className="inner-box">
                        <div className="icon-outer">
                            <span className="icon-bg"></span>
                            <div className="icon-box"><img src="assets/images/images/main.png" alt="" /></div>
                        </div>
                        <h3>Website Maintenance</h3>
                        <div className="text">
                            Keep your website updated, secure, fast, and running smoothly at all times.
                        </div>
                    </div>
                </div>

                {/* Digital Marketing */}
                <div className="service-block wow fadeInUp" data-wow-delay="600ms" data-wow-duration="1500ms">
                    <div className="inner-box">
                        <div className="icon-outer">
                            <span className="icon-bg"></span>
                            <div className="icon-box"><img src="assets/images/images/1.png" alt="" /></div>
                        </div>
                        <h3>Digital Marketing</h3>
                        <div className="text">
                            Grow your brand with targeted digital campaigns across multiple platforms.
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</section>


    {/* <!--Locations Section--> */}
    {/* <section className="locations-section">
        <div className="auto-container">
            <div className="sec-title centered">
                <div className="upper-text">AlphaBlind IT Services</div>
                <h2>Trusted By 5M AlphaBlind IT Customers Around The World</h2>
                <div className="lower-text">Sit amet consectetur adipisicing elitm sed eiusmod temp sed incididunt labore dolore magna aliquatenim veniam quis ipsum nostrud exer citation ullamco laboris.</div>
            </div>
            <div className="map-box">
                <div className="map-image">
                    <img src="assets/images/icons/map-pattern.png" alt="" title="" />
                </div>

                <div className="location-point loc-one">
                    <div className="inner">100+ Projects Done For Local IT Companies</div>
                </div>
                <div className="location-point loc-two">
                    <div className="inner">100+ Projects Done For Local IT Companies</div>
                </div>
                <div className="location-point loc-three">
                    <div className="inner">100+ Projects Done For Local IT Companies</div>
                </div>
                <div className="location-point loc-four">
                    <div className="inner">100+ Projects Done For Local IT Companies</div>
                </div>
                <div className="location-point loc-five">
                    <div className="inner">100+ Projects Done For Local IT Companies</div>
                </div>
                <div className="location-point loc-six">
                    <div className="inner">100+ Projects Done For Local IT Companies</div>
                </div>
                <div className="location-point loc-seven">
                    <div className="inner">100+ Projects Done For Local IT Companies</div>
                </div>
                <div className="location-point loc-eight">
                    <div className="inner">100+ Projects Done For Local IT Companies</div>
                </div>
                <div className="location-point loc-nine">
                    <div className="inner">100+ Projects Done For Local IT Companies</div>
                </div>
                <div className="location-point loc-ten">
                    <div className="inner">100+ Projects Done For Local IT Companies</div>
                </div>
                <div className="location-point loc-eleven">
                    <div className="inner">100+ Projects Done For Local IT Companies</div>
                </div>
                <div className="location-point loc-twelve">
                    <div className="inner">100+ Projects Done For Local IT Companies</div>
                </div>

            </div>
        </div>
    </section> */}

     {/* <!--Default Background Section--> */}
    <section className="default-bg-section">
        <div className="image-layer" style={{ backgroundImage: `url("assets/images/images/image-1.jpg")` }}></div>

        <div className="auto-container">
            <div className="content-box">
                <h2>Our IT Solutions will get you on move towards your destination faster than rivals in a more reliably way!</h2>
                <div className="link-box">
                    <Link to="about.html" className="theme-btn btn-style-one"><div className="btn-title">Proven IT Solutions</div></Link>
                </div>
            </div>
        </div>
    </section>

    {/* <!--Fun Facts Section--> */}
    {/* <section className="fun-facts-section">
  <div className="auto-container">
    <div className="fact-counter">
      <div className="row clearfix">

        <div className="counter-column col-lg-4 col-md-4 col-sm-12">
          <div className="inner wow fadeInUp" data-wow-delay="0ms">
            <div className="upper-title">Projects Delivered</div>
            <div className="count-box">
              <span className="count-text" data-speed="1000" data-stop="250">120</span>+
            </div>
            <div className="counter-title">Across Multiple Industries</div>
          </div>
        </div>

        <div className="counter-column col-lg-4 col-md-4 col-sm-12 wow fadeInUp">
          <div className="inner wow fadeInUp" data-wow-delay="300ms">
            <div className="upper-title">Satisfied Clients</div>
            <div className="count-box">
              <span className="count-text" data-speed="1000" data-stop="180">85</span>+
            </div>
            <div className="counter-title">Worldwide</div>
          </div>
        </div>

        <div className="counter-column col-lg-4 col-md-4 col-sm-12 wow fadeInUp">
          <div className="inner wow fadeInUp" data-wow-delay="600ms">
            <div className="upper-title">Years of Experience</div>
            <div className="count-box">
              <span className="count-text" data-speed="1000" data-stop="8">7</span>+
            </div>
            <div className="counter-title">In Web & App Development</div>
          </div>
        </div>

      </div>
    </div>
  </div>
</section> */}


    {/* <!--Separator--> */}
    <div className="theme-separator"></div>


    <section className="sponsors-section">
        <div className="sponsors-outer">
            {/* <!--Sponsors--> */}
            <div className="auto-container">
                {/* <!--Sponsors Carousel--> */}
                <OwlCarousel className="sponsors-carousel theme-carousel owl-theme owl-carousel" {...options3}>
                    <div className="slide-item"><figure className="image-box"><Link to="#"><img src="images/clients/1.jpg" alt="" /></Link></figure></div>
                    <div className="slide-item"><figure className="image-box"><Link to="#"><img src="images/clients/2.jpg" alt="" /></Link></figure></div>
                    <div className="slide-item"><figure className="image-box"><Link to="#"><img src="images/clients/3.jpg" alt="" /></Link></figure></div>
                    <div className="slide-item"><figure className="image-box"><Link to="#"><img src="images/clients/4.jpg" alt="" /></Link></figure></div>
                    <div className="slide-item"><figure className="image-box"><Link to="#"><img src="images/clients/5.jpg" alt="" /></Link></figure></div>
                    <div className="slide-item"><figure className="image-box"><Link to="#"><img src="images/clients/1.jpg" alt="" /></Link></figure></div>
                    <div className="slide-item"><figure className="image-box"><Link to="#"><img src="images/clients/2.jpg" alt="" /></Link></figure></div>
                    <div className="slide-item"><figure className="image-box"><Link to="#"><img src="images/clients/3.jpg" alt="" /></Link></figure></div>
                    <div className="slide-item"><figure className="image-box"><Link to="#"><img src="images/clients/4.jpg" alt="" /></Link></figure></div>
                    <div className="slide-item"><figure className="image-box"><Link to="#"><img src="images/clients/5.jpg" alt="" /></Link></figure></div>
                </OwlCarousel>
            </div>
        </div>
    </section>
    </>
  );
};

export default Home;